















import Vue from 'vue'
export default Vue.extend({
  props: {
    txtColor: {
      type: String,
      default: () => 'text-gray-100'
    },
    href: {
      type: String,
      default: () => 'javascript:;'
    },
    size: {
      type: String,
      default: () => 'sm'
    },
    text: {
      type: String,
      required: true
    },
    tag: {
      type: String,
      default: () => 'button'
    }
  }
})
